import Component from '@glimmer/component';

export interface RecommendationDetailsModalSignature {
  Args: {
    isOpen: boolean;
    toggleModal: (val: boolean) => void;
    recommendation: any;
  };
  Blocks: {
    default: [];
  };
  Element: null;
}

export default class RecommendationDetailsModal extends Component<RecommendationDetailsModalSignature> {
  get iconColor() {
    if (this.args.recommendation.type === 'action') {
      return 'text-red-700';
    }
    return 'text-amber-700';
  }

  get iconBgColor() {
    if (this.args.recommendation.type === 'action') {
      return 'bg-red-100';
    }
    return 'bg-amber-100';
  }
}
